import React, { Component } from 'react';

import phpVars from 'phpVars';
import SystemAdminDashboard from "./s360components/SystemAdminDashboard";
import AdminUsersDashboard from "./s360components/AdminUsersDashboard";
import ConcernReports from "./s360components/ConcernReports";
import UsageDashboard from "./s360components/UsageDashboard";
import Hints from "./s360components/Login/Hints";
import LearningJournalPage from "root/s360components/LearningJournal/LearningJournalPage";
import ReportsPage from "root/s360components/Reports/ReportsPage";
import SchoolsAndSchoolUsers from "root/s360components/SchoolsAndSchoolUsers/SchoolsAndSchoolUsers";
import RegistrationPage from "root/s360components/Registration/RegistrationPage";
import MaintenancePage from "root/s360components/Maintenance/MaintenancePage";
import TeacherLoadPage from "root/s360components/TeacherLoad/TeacherLoadPage";
import UserEditPage from "root/s360components/UserRename/UserEditPage";
import LJAppUsagePage from "root/s360components/LJAppUsage/LJAppUsagePage";
import AttendanceReportsPage from "root/s360components/Reports/AttendanceReportsPage";
import LunchReportPage from "root/s360components/LunchReport/LunchReportPage";
import FutureAbsencePage from "root/s360components/FutureAbsence/FutureAbsencePage";
import * as Sentry from "@sentry/react";
import AdminUsersDashboardProvider from "root/s360components/AdminUsersDashboardProvider";
import {createRoot} from "react-dom/client";

import 'react-responsive-modal/styles.css';

export const SENTRY_DSN = "https://0a70b4cfd4ede1dff4a48563dc7557a0@o4507802868383744.ingest.de.sentry.io/4508336462954576";
export const SENTRY_REPORTING_ENABLED = false; //Sentry still initialises but doesn't send data
export const SENTRY_ENABLED = false; //False = Disable Sentry's overheads by conditional initialisation of the Sentry object.

class MyApp extends Component {


    renderComponent ()
    {
        switch ( phpVars.div )
        {
            case 'teacherAdminDashboard-div':
                return (
                        <AdminUsersDashboard school_id={phpVars.school_id} user_id={phpVars.user_id} eschools_admin={phpVars.eschools_admin}
                                         concern_reports_access={phpVars.concern_reports_access} pupil_notes_access={phpVars.pupil_notes_access}
                                         online_safety_audit_enabled={phpVars.online_safety_audit_enabled} user_type={phpVars.user_type}/>
                )

            case 'systemAdminDashboard-div':
                return (
                    <SystemAdminDashboard school_id={phpVars.school_id} user_id={phpVars.user_id}/>
                )

            case 's360Dashboards-div':
                return (
                    <UsageDashboard school_id={phpVars.school_id} user_id={phpVars.user_id}/>
                )

            case 'concernreports-div':
                return (
                    <ConcernReports school_id={phpVars.school_id} user_id={phpVars.user_id} user_type={phpVars.user_type} role={phpVars.role}/>
                )

            case 'login-react-div':
                return (
                    <Hints current_url={phpVars.current_url} link={phpVars.link_page}/>
                )

            case 'learning-journal-div':
                return (
                    <LearningJournalPage school_id={phpVars.school_id}/>
                )

            case 'reports-div':
                return (
                    <ReportsPage rval={phpVars.rval} type={phpVars.type} home={phpVars.home}/>
                )

            case 'attendance-reports-div':
                return (
                    <AttendanceReportsPage rval={phpVars.rval} type={phpVars.type} home={phpVars.home} menu={phpVars.menu}/>
                )

            case 'registration-div':
                return (
                    <RegistrationPage school_id={phpVars.school_id} class_id_filter={phpVars.class_id}/>
                )

            case 'schoolandschoolusers-div':
                return (
                    <SchoolsAndSchoolUsers school_id = {phpVars.school_id} user_id = {phpVars.user_id} user_type={phpVars.user_type} menu={phpVars.menu} filter ={phpVars.filter} page = {phpVars.page}/>
                )

            case 'maintenance-div':
                return (
                    <MaintenancePage school_id = {phpVars.school_id} user_id = {phpVars.user_id} user_type={phpVars.user_type} menu={phpVars.menu} filter ={phpVars.filter} page = {phpVars.page}/>
                )

            case 'teacherload-div':
                return (
                    <TeacherLoadPage school_id = {phpVars.school_id} user_id = {phpVars.user_id} user_type={phpVars.user_type} menu={phpVars.menu} filter ={phpVars.filter} page = {phpVars.page}/>
                )

            case 'userrename-div':
                return (
                    <UserEditPage school_id = {phpVars.school_id} user_id = {phpVars.user_id} user_type={phpVars.user_type} menu={phpVars.menu} filter ={phpVars.filter} page = {phpVars.page}/>
                )

            case 'lj-app-usage-div':
                return (
                    <LJAppUsagePage />
                )

            case 'lunch-report-div':
                return (
                    <LunchReportPage school_id = {phpVars.school_id} rval={phpVars.rval}/>
                )

            case 'future-absence-div':
                return (
                    <FutureAbsencePage school_id={phpVars.school_id} class_id_filter={phpVars.class_id}/>
                )

            default:
                return null
        }
    }

    render() {

        if (SENTRY_ENABLED === true)
        {
            Sentry.init({
                dsn: SENTRY_DSN,
                enabled: SENTRY_REPORTING_ENABLED,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration(),
                ],
                // Tracing
                tracesSampleRate: 1.0, //  Capture 100% of the transactions
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ["https://school360.localdev", "https://v8.school360.co.uk", "https://school360.co.uk"],
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }

        return ( this.renderComponent());
    }
}

const container = document.getElementById(phpVars.div);

const atts = container.dataset;

const root = createRoot(container);
root.render(<MyApp dataset={atts}/>);

